import { Card, Modal } from "@mantine/core";
import { useState } from "react";
import MembersTableDepricated from "../../app/routes/admin/members/MembersTableDepricated";
import { useAppSelector } from "../../hooks";
import WidgetWrapper from "../WidgetWrapper/WidgetWrapper";

const OrgListWidget: React.FC<any> = () => {
  const [openOrgListModal, setOpenOrgListModal] = useState<boolean>(false);
  const [showSettings, setShowSettings] = useState<boolean>(false);
  const project = useAppSelector((state) => state.adminReducer.project);

  return (
    <WidgetWrapper
      title="Medlemmer"
      widgetKey="orgList"
      onFullscreenClick={() => setOpenOrgListModal(true)}
      onShowSettingsClick={() => setShowSettings(!showSettings)}
    >
      {project.members?.length > 0 && (
        <>
          <MembersTableDepricated members={project.members} projectId={project._id} showSettings={showSettings} />
          <Modal
            opened={openOrgListModal}
            onClose={() => setOpenOrgListModal(false)}
            title="Prosjektmedlemmer"
            size="80vw"
            centered
            overlayProps={{ blur: 2 }}
          >
            <Card px="sm" pt={"xs"} h={"80vh"} bg={"#fafafb"} bd={"1px solid var(--mantine-color-warmgray-1)"}>
              <MembersTableDepricated members={project.members} projectId={project._id} />
            </Card>
          </Modal>
        </>
      )}
    </WidgetWrapper>
  );
};
export default OrgListWidget;
